import { createStyles, Grid, GridProps, IconButton, makeStyles, Theme } from '@material-ui/core';
import { AddCircle, RemoveCircleOutline } from '@material-ui/icons';
import React, { ReactNode, useState } from 'react';
import ConfirmationDialog from '../ConfirmationDialog';

export type MultiRowInputProps = {
  ContainerComponentProps?: GridProps;
  index: number;
  onAdd?: () => void;
  onRemove?: (rowIndex: number) => void;
  confirmModalText?: string;
  confirmModal?: boolean;
  children: ReactNode;
  disableAdd?: boolean;
  disabled?: boolean;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    delete: {
      color: theme.palette.text.secondary,
    },
    add: {
      color: theme.palette.primary.main,
    },
  }),
);

export const MultiRowInput = ({
  ContainerComponentProps,
  onAdd = () => undefined,
  onRemove = () => undefined,
  confirmModal = true,
  index: indexProp,
  confirmModalText = `You are about to remove an entry. Are you sure you want to continue?`,
  children = null,
  disableAdd = false,
  disabled = false,
}: MultiRowInputProps): JSX.Element => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const deleteRow = (index: number) => {
    onRemove(index);
  };

  const addRow = () => onAdd();

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleConfirm = () => {
    deleteRow(indexProp);
    handleClose();
  };

  return (
    <>
      <Grid item container xs={12} role="row" {...ContainerComponentProps}>
        <Grid item xs={11}>
          {children}
        </Grid>
        <Grid item xs={1}>
          {indexProp == 0 ? (
            <IconButton
              onClick={addRow}
              className={classes.add}
              aria-label="add-row-button"
              data-testid="add-row-button"
              disabled={disabled ? disabled : disableAdd}
            >
              <AddCircle />
            </IconButton>
          ) : (
            <IconButton
              onClick={() => (confirmModal ? handleOpen() : deleteRow(indexProp))}
              className={classes.delete}
              aria-label="delete-row-button"
              data-testid="delete-row-button"
              disabled={disabled}
            >
              <RemoveCircleOutline />
            </IconButton>
          )}
        </Grid>
      </Grid>
      <ConfirmationDialog open={open} onClose={handleClose} onConfirm={handleConfirm} dialogText={confirmModalText} />
    </>
  );
};

export default MultiRowInput;
